import http from './client';

/**
 * Notificaciones (config) — tag Notificaciones en api_doc/openapi.yaml
 */

export const notificationEventsApi = {
  list: () => http.get('/notification-events'),
  getById: (id) => http.get(`/notification-events/${id}`),
  getByKey: (key) => http.get(`/notification-events/by-key/${encodeURIComponent(key)}`),
  create: (body) => http.post('/notification-events', body),
  update: (id, body) => http.put(`/notification-events/${id}`, body),
  remove: (id) => http.delete(`/notification-events/${id}`),
};

export const notificationRulesApi = {
  list: (params) => http.get('/notification-rules', { params }),
  get: (id) => http.get(`/notification-rules/${id}`),
  create: (body) => http.post('/notification-rules', body),
  update: (id, body) => http.put(`/notification-rules/${id}`, body),
  remove: (id) => http.delete(`/notification-rules/${id}`),
};

export const notificationGroupsApi = {
  list: () => http.get('/notification-groups'),
  get: (id) => http.get(`/notification-groups/${id}`),
  create: (body) => http.post('/notification-groups', body),
  update: (id, body) => http.put(`/notification-groups/${id}`, body),
  remove: (id) => http.delete(`/notification-groups/${id}`),
  listUsers: (groupId) => http.get(`/notification-groups/${groupId}/users`),
  addUser: (groupId, userId) =>
    http.post(`/notification-groups/${groupId}/users`, { user_id: userId }),
  removeUser: (groupId, userId) =>
    http.delete(`/notification-groups/${groupId}/users/${userId}`),
};
